export const LANGS = ['ua', 'ru']; 
export const DEFAULT_LANG = LANGS[0];
export const DEFAULT_LANG_ROUTE = '';
export const GOOGLE_MAPS_KEY = 'AIzaSyAiwLyPsExhVdhK6jJI-eYMeEFkSvkHHdc';
export const COORDS_PELETEX = [50.5443651, 30.6536747];
